import { TxnEventExternalId } from 'app/shared/types/eventExternalIds';

const BASE = ['transactionScore'];

export const TRANSACTION_SCORE_QUERY_KEYS = {
  getTransactionRiskScoreEvidence: (eventID: TxnEventExternalId) => [
    ...BASE,
    'evidence',
    eventID,
  ],
};
